import {connect} from 'react-redux';

import SocialCard from './SocialCard';
import protocolActions from '../../redux/actions/protocol.actions';

const mapDispatchToProps = {
    onClickConnect: protocolActions.openAddFriendConnections,
    onClickFind: protocolActions.openAddFriends
};

export default connect(
    undefined,
    mapDispatchToProps
)(SocialCard);
